import type { TAddress } from '@verifime/utils';

// PlaceResponse fields mirror the VAS OpenAPI spec; the addressSchemas
// export from @verifime/address-api-definition provides a Zod type. We
// accept a loose input shape here because Zodios codegen uses
// `.passthrough()`, which types every property as optional. The function
// is also used by the view component's happy-path assertion plumbing, so
// it needs to be tolerant to sparse inputs.
type PlaceLike = {
  secondaryAddress?: string | null;
  addressNumber?: string | null;
  streetName?: string | null;
  streetType?: string | null;
  locality?: string | null;
  district?: string | null;
  region?: { name?: string | null } | null;
  postalCode?: string | null;
  country?: { code2?: string | null } | null;
};

export function mapPlaceToAddress(place: PlaceLike, countryCode: string): Partial<TAddress> {
  return {
    unitNumber: place.secondaryAddress ?? undefined,
    streetNumber: place.addressNumber ?? undefined,
    streetName: place.streetName ?? undefined,
    streetType: place.streetType ?? undefined,
    suburb: place.locality ?? undefined,
    city: place.district ?? undefined,
    state: place.region?.name ?? undefined,
    postcode: place.postalCode ?? undefined,
    countryCode: place.country?.code2 ?? countryCode,
  };
}
